import { useParams } from 'react-router-dom';
import StudentProfileEditor from 'components/student-profile/StudentProfileEditor';

// Los afiliados conservan el alcance que tenían: sin datos de salud, colegio
// anterior, referencias ni acudientes. Vuelven a la página anterior porque no
// tienen un detalle de estudiante propio.
export default function ModifyStudentAffiliate() {
  const { id } = useParams();
  return <StudentProfileEditor studentId={id} sections={['principal', 'basic', 'identity']} basicVariant="limited" />;
}
